import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";

import Badge, { propTypes as BadgePropTypes } from "../Badge";

/**
 * prop definition
 */
const propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.any.isRequired,
      slug: PropTypes.string.isRequired,
      component: PropTypes.any.isRequired,
      badge: PropTypes.shape(BadgePropTypes)
    })
  ),
  onSelect: PropTypes.func,
  navProps: PropTypes.object,
  childProps: PropTypes.object,
  contentProps: PropTypes.object,
  activeKey: PropTypes.string.isRequired
};

const defaultProps = {
  onSelect: () => {}
};

const Template = ({
  tabs,
  navProps,
  onSelect,
  activeKey,
  childProps,
  contentProps,
  ...props
}) => {
  /**
   * variable
   */
  const tab = tabs.find(({ slug }) => slug === activeKey);

  return (
    <Tab.Container {...{ activeKey, ...props }}>
      <Nav variant="tabs" {...{ onSelect, ...navProps }}>
        {tabs.map(({ slug, name, badge }, key) => (
          <Nav.Item key={key}>
            <NavLink eventKey={slug}>
              <span>{name}</span>
              {badge && <Badge {...badge} />}
            </NavLink>
          </Nav.Item>
        ))}
      </Nav>
      <Tab.Content {...contentProps}>
        {tab && <tab.component {...childProps} />}
      </Tab.Content>
    </Tab.Container>
  );
};

/**
 * style
 */
const NavLink = styled(Nav.Link)`
  gap: 0.25rem;
  height: 100%;
  display: flex;
  position: relative;
  align-items: center;
`;

Template.propTypes = propTypes;
Template.defaultProps = defaultProps;

export default Template;
